window.popup = ({ id, csrf_token, popup_after_seconds }) => {
    return {
        init($dispatch) {
            setTimeout(
                () => {
                    $dispatch('show-modal', { id });
                },
                popup_after_seconds ? popup_after_seconds * 1000 : 500,
            );
        },
        onClose(e) {
            if (e.detail === id) {
                fetch('/popup-closed', {
                    method: 'POST',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                        'X-CSRF-Token': csrf_token,
                    },
                    body: JSON.stringify({
                        id,
                    }),
                });
            }
        },
    };
};
